import { createApp } from 'vue'
import App from './apps/isigma-alerts/AlertsApp.vue'

createApp(App).mount('#alerts-app')
